import { _$ } from './Fascino.js'
import { Fascino } from './core.js'

export default {
	_$,
	Fascino
}